(function () {
  'use strict';

  angular.module('mgpCorregedoriaApp.validacao')
    .controller('ModalInstanceDetalheAnalitico', ModalInstanceDetalheAnalitico);

  function ModalInstanceDetalheAnalitico($uibModalInstance, detalhamentoAnalitico){

    var vm = this;
    vm.detalhamentoAnalitico = detalhamentoAnalitico;
    vm.close = close;

    function close(){
      $uibModalInstance.dismiss('cancel');
    }
  }

})();
